import { render, staticRenderFns } from "./LoginPasswordChange.vue?vue&type=template&id=d899acac&scoped=true&"
import script from "./LoginPasswordChange.vue?vue&type=script&lang=js&"
export * from "./LoginPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./LoginPasswordChange.vue?vue&type=style&index=0&id=d899acac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d899acac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d899acac')) {
      api.createRecord('d899acac', component.options)
    } else {
      api.reload('d899acac', component.options)
    }
    module.hot.accept("./LoginPasswordChange.vue?vue&type=template&id=d899acac&scoped=true&", function () {
      api.rerender('d899acac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginPasswordChange.vue"
export default component.exports